import tokens from 'airship-design-system/tokens.json'

export type ShadowContext = keyof typeof tokens.shadow
export type ShadowContextShadows = {
  focus: keyof typeof tokens.shadow.focus
}

/* Transforms this:

  "shadow": {
    "focus": {
      "0": {
        "x": {
          "value": 0,
          "type": "x"
        },
        "y": {
          "value": 0,
          "type": "y"
        },
        "blur": {
          "value": 0,
          "type": "blur"
        },
        "spread": {
          "value": 0.5,
          "type": "spread"
        },
        "color": {
          "value": "#626e93",
          "type": "color"
        },
        "type": {
          "value": "dropShadow",
          "type": "type"
        }
      },
      "1": {
        "x": {
          "value": 0,
          "type": "x"
        },
        "y": {
          "value": 0,
          "type": "y"
        },
        "blur": {
          "value": 0,
          "type": "blur"
        },
        "spread": {
          "value": 4,
          "type": "spread"
        },
        "color": {
          "value": "#1a48d666",
          "type": "color"
        },
        "type": {
          "value": "dropShadow",
          "type": "type"
        }

      }
      ...
    }

  Into this:

  {
    "focus": "0 0 0 0.5px #626e93,0 0 0 4px #1a48d666"
  }

  @NOTE: These values are meant to be used with the `shadow` css style, NOT `dropShadow`.
*/
const shadow = Object.keys(tokens.shadow).reduce((obj, key) => {
  obj[key as ShadowContext] = Object.keys(
    tokens.shadow[key as ShadowContext]
  ).reduce((value, innerKey) => {
    const shadowContext = tokens.shadow[key as ShadowContext]
    const subContext = shadowContext[innerKey as keyof typeof shadowContext]
    const separator = value ? ',' : ''
    value += `${separator}${subContext.x.value} ${subContext.y.value} ${subContext.blur.value} ${subContext.spread.value} ${subContext.color.value}`
    return value
  }, '' as string)
  return obj
}, {} as Record<ShadowContext, string>)

export default shadow
